import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const PROMO_BANNER_ALL_CLASSES_I18N_NAMESPACE =
  '@mc/promos/experiments/pen-7584_v1_promo_banner_all_classes'

export const i18nInstance = registerI18nResources({
  namespace: PROMO_BANNER_ALL_CLASSES_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
